import React, { useEffect } from "react";
import "./styles/index.scss";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import Button from "../../common/forms/button";
import Actions from "../../../actions";
import { connect } from "react-redux";
import InfoIcon from "../../common/icons/infoIcon";
import { clickToLinkHandler } from "../../../helpers/utils";

const ActivationLinkForm = (props) => {
  const { sentLetterForActivate, email, resend } = props;

  useEffect(() => {
    if (resend) {
      clickToLinkHandler("/activate");
    }
  }, [resend]);

  const handleSubmit = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      sentLetterForActivate(email);
    }
  };

  return (
    <React.Fragment>
      <div className="activation-link-form-container">
        <div className="title-container">
          <InfoIcon />
          <div className="title-container-wrapper">
            <div className="title">Registration</div>
            <div className="description">Entered email already used</div>
          </div>
        </div>
        <Delimiter type="headline" shift="18" />
        <div className="title">{email}</div>
        <div className="description">
          This email already used in previous registration{" "}
          <strong>but account still not activated</strong>. We can send one more
          email to activate your account.
        </div>
        <Delimiter type="internal" shift="18" />
        <Button
          type="primary"
          size="large"
          children={"Send Activation Link again"}
          onClick={handleSubmit}
        />
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state, props) => {
  const { formErrors: errors, resend } = state.auth;
  const email = props.match.params.email;
  return {
    errors,
    email,
    resend,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sentLetterForActivate: function (email) {
    dispatch(Actions.sentLetterForActivate(email));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivationLinkForm);
